import { Box, Fab, Grid, Typography, alpha } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkIcon from "@mui/icons-material/Link";
import { Link } from "react-router-dom";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import MapIcon from "@mui/icons-material/Map";
import CopyRight from "./CopyRight";
import { YouTube } from "@mui/icons-material";

const Contact = () => {
  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 3, md: 20, lg: 30 },
        backgroundColor: "#1a5b8e",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={3} sx={{ xs: 5, md: 0 }}>
          <Typography sx={{ color: "#fff" }} variant="h6">
            Follow us:{" "}
          </Typography>
          <Typography sx={{ color: "#fff", mt: 2 }} variant="h5">
            CMJ Co.,Ltd
          </Typography>
          <Box sx={{ mt: 3 }}>
            <a href="www.facebook.com/CloverMandalayAgency?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
              <Fab
                size="small"
                sx={{
                  boxShadow: "none",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(5px)",
                  transition: "all 0.3s ease-in-out",
                  mr: 3,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    transform: "scale(1.05)",
                    transition: "transform 0.3s ease-in-out",
                  },
                }}
              >
                <FacebookIcon sx={{ color: "#fff" }} />
              </Fab>
            </a>
            <a target="_blink" href="https://youtube.com/@clovermandalay?si=_VynZQVNyVJ2kO0B" rel="noopener noreferrer">
              <Fab
                size="small"
                sx={{
                  boxShadow: "none",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(5px)",
                  transition: "all 0.3s ease-in-out",
                  mr: 3,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    transform: "scale(1.05)",
                    transition: "transform 0.3s ease-in-out",
                  },
                }}
              >
                <YouTube sx={{ color: "#fff" }} />
              </Fab>
            </a>
            <a href="https://clovermandalay.com" target="_blank" rel="noopener noreferrer">
              <Fab
                size="small"
                sx={{
                  boxShadow: "none",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(5px)",
                  transition: "all 0.3s ease-in-out",
                  mr: 3,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    transform: "scale(1.05)",
                    transition: "transform 0.3s ease-in-out",
                  },
                }}
              >
                <LinkIcon sx={{ color: "#fff" }} />
              </Fab>
            </a>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={3} sx={{ xs: 5, md: 0 }}>
          <Typography
            sx={{ textTransform: "uppercase", color: "#fff", fontSize: "20px" }}
          >
            Quick Links
          </Typography>
          <Link to={"/"}>
            <Typography
              sx={{
                textTransform: "uppercase",
                color: alpha("#fff", 0.5),
                mt: 2,
              }}
            >
              home
            </Typography>
          </Link>
          <Link to={"/jobs"}>
            <Typography
              sx={{
                textTransform: "uppercase",
                color: alpha("#fff", 0.5),
                mt: 2,
              }}
            >
              jobs
            </Typography>
          </Link>
          <Link to={"/about-us"}>
            <Typography
              sx={{
                textTransform: "uppercase",
                color: alpha("#fff", 0.5),
                mt: 2,
              }}
            >
              about
            </Typography>
          </Link>
        </Grid>
        <Grid item xs={12} md={12} lg={6} sx={{ xs: 5, md: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <LocalPhoneIcon sx={{ mr: 2, color: "#fff" }} />
            <Typography sx={{ color: alpha("#fff", 0.5) }}>
              052-462-9104
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <EmailIcon sx={{ mr: 2, color: "#fff" }} />
            <Typography sx={{ color: alpha("#fff", 0.5) }}>
              job@cmj.vc
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <MapIcon sx={{ mr: 2, color: "#fff" }} />
            <Typography sx={{ color: alpha("#fff", 0.5) }}>
              本社 : 〒453-0803 名古屋市中村区長戸井町２丁目20番１号<br/>
              東京営業所 : 〒123-0873 東京都足立区扇2丁目14番30号
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <CopyRight />
    </Box>
  );
};

export default Contact;
